import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useFacilityRequiresCardOnFile_facility$key } from "./__generated__/useFacilityRequiresCardOnFile_facility.graphql";

export const useFacilityRequiresCardOnFile = (
  facilityRef: useFacilityRequiresCardOnFile_facility$key | null
) => {
  const facility = useFragment(
    useFacilityRequiresCardOnFileFragmentString,
    facilityRef
  );
  const supportsPublic = !!facility?.club?.supportsPublic;
  const requirePaymentCardOnFile =
    !!facility?.publicBookingPermissionSet?.requirePaymentCardOnFile;
  return supportsPublic && requirePaymentCardOnFile;
};

const useFacilityRequiresCardOnFileFragmentString = graphql`
  fragment useFacilityRequiresCardOnFile_facility on Facility {
    publicBookingPermissionSet {
      requirePaymentCardOnFile
    }
    club {
      supportsPublic
    }
  }
`;
